import { FaWhatsapp } from "react-icons/fa";
import { Button } from "../../../components/Button";
import { SectionSubTitle } from "../../../components/SectionTitle";
import { Spacer } from "../../../components/Spacer";
import { FadeUp } from "../../../components/Transitions/FadeUp";

const contacts = [
  {
    name: "Natalia",
    phone: "+34 613 51 16 27",
    whatsappHref: "https://wa.me/34613511627",
  },
  {
    name: "David",
    phone: "+34 650 36 55 41",
    whatsappHref: "https://wa.me/34650365541",
  },
];

export const Contact = () => {
  return (
    <FadeUp>
      <SectionSubTitle
        title="¿Tienes alguna duda?"
        subtitle="Escríbenos por WhatsApp y estaremos encantados de ayudarte."
        textColor="text-secondary-light"
      />

      <Spacer />
      <Spacer />

      <div className="mb-8 grid gap-4 md:grid-cols-2 md:gap-2 max-w-80 md:max-w-220 ml-auto mr-auto">
        {contacts.map((c) => (
          <div
            key={c.name}
            className="flex flex-col h-full w-full md:m-auto md:max-w-100"
          >
            {/* <div className="text-left pl-4 pb-2 text-secondary-light eyebrow-md opacity-80">
              {c.phone}
            </div> */}
            <Button
              bgColor="white"
              textColor="primary-text"
              borderColor="primary-text"
              to={{
                href: c.whatsappHref,
                target: "_blank",
              }}
              className="m-auto shadow-md"
              icon={<FaWhatsapp aria-hidden="true" size={32} />}
            >
              <div className="flex items-center justify-center text-primary-text">
                <span className="text-md md:text-lg relative -left-3">
                  {c.name}
                </span>
              </div>
            </Button>
          </div>
        ))}
      </div>
    </FadeUp>
  );
};
